import PropTypes from 'prop-types';
import React from 'react';
import { SelectSearch } from 'mol-ui';
import { parseCampaignParticipantStatus } from 'core/Campaign';
import { useTranslation } from 'react-i18next';

const CampaignParticipantStatusPicker = ({
    disabled,
    hasError,
    height = '40px',
    margin,
    onChange,
    value,
    width = '100%'
}) => {

    const { t } = useTranslation();

    const selectProps = {
        disabled,
        hasError,
        height,
        onChange,
        value,
        width
    };

    const keys = ['invited', 'registered', 'accepted', 'rejected', 'present', 'absent'];

    const options = [{
        label: t('Todos los estados'),
        value: ''
    }, ...keys.map(value => ({
        label: parseCampaignParticipantStatus(value)?.label,
        value
    }))];

    return (
        <SelectSearch
            { ...selectProps }
            fontSize="11px"
            margin={ margin ? margin : '0px 0px 10px 0px' }
            options={ options }
        />
    );
};

CampaignParticipantStatusPicker.propTypes = {
    disabled: PropTypes.bool,
    hasError: PropTypes.bool,
    height: PropTypes.string,
    margin: PropTypes.string,
    onChange: PropTypes.func,
    value: PropTypes.string,
    width: PropTypes.string
};

export default CampaignParticipantStatusPicker;
